import React from "react";
import { AxiosResponse } from "axios";
import { connect } from "react-redux";

import Layout from "app/components/Layout";
import SignInForm from "./components/SignInForm";

import { signIn } from "app/api/redux/Auth/actions";
import { openSocket } from "app/api/redux/Chat/actions";
import { ISignInRequest } from "app/api/types";

import "./styles.scss";
import { withRouter, RouteComponentProps } from "react-router";
import {loginChat} from "app/api/redux/Chat/actions";

interface IProps extends RouteComponentProps {
  signIn: (data: ISignInRequest) => Promise<AxiosResponse>;
  loginChat: (data: {email: string, password: string}) => Promise<void>;
  openSocket: () => void;
  isLoading: boolean;
  isSignFail: boolean;
}

interface IState {
  errors: any;
}

class SignIn extends React.PureComponent<IProps, IState> {
  state: IState = {
    errors: []
  };

  signIn = (data: ISignInRequest) => {
    this.props.loginChat({
      email: data.email,
      password: data.password,
    }).then(() => this.props.openSocket());

    this.props
      .signIn(data)
      .then(() => this.props.history.push("/"))
      .catch(errors => this.setState({ errors }));
  };

  render() {
    return (
      <Layout>
        <SignInForm
          errors={this.state.errors}
          onSubmit={this.signIn}
          isLoading={this.props.isLoading}
          isSignFail={this.props.isSignFail}
        />
      </Layout>
    );
  }
}
const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.isLoading,
    isSignFail: state.auth.isSignFail
  };
};

export default connect(mapStateToProps, {
  signIn,
  loginChat,
  openSocket,
})(withRouter(SignIn));
